import { AsyncPipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormInputAutofocusDirective, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  BadgeComponent,
  DividerComponent,
  ElevioTriggerDirective,
  LoaderComponent,
  NotificationModule,
  PageComponent,
} from '@ftr/foundation'
import { PasswordComponent } from '@ftr/ui-password'
import { AppLoaderComponent } from '../app-loader'
import { LoginComponent } from '../login'
import { LoginFormComponent } from '../login-form'
import { LogoutComponent } from '../logout'
import { SingleSignOnModule } from '../single-sign-on'

@NgModule({
  imports: [
    RouterModule,
    SingleSignOnModule,
    DividerComponent,
    PageComponent,
    LoaderComponent,
    NotificationModule,
    AppLoaderComponent,
    PasswordComponent,
    UntypedFormComponent,
    FormInputComponent,
    FormInputAutofocusDirective,
    AsyncPipe,
    BadgeComponent,
    ElevioTriggerDirective,
  ],
  declarations: [LoginComponent, LoginFormComponent, LogoutComponent],
  exports: [LoginComponent, LogoutComponent],
})
export class LoginModule {}
